var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 9.16667V6.66667C14.6666 4.36548 12.8012 2.5 10.5 2.5C8.19879 2.5 6.33331 4.36548 6.33331 6.66667V9.16667M7.83331 17.5H13.1666C14.5668 17.5 15.2668 17.5 15.8016 17.2275C16.272 16.9878 16.6545 16.6054 16.8942 16.135C17.1666 15.6002 17.1666 14.9001 17.1666 13.5V13.1667C17.1666 11.7665 17.1666 11.0665 16.8942 10.5317C16.6545 10.0613 16.272 9.67883 15.8016 9.43915C15.2668 9.16667 14.5668 9.16667 13.1666 9.16667H7.83331C6.43318 9.16667 5.73312 9.16667 5.19834 9.43915C4.72793 9.67883 4.34548 10.0613 4.1058 10.5317C3.83331 11.0665 3.83331 11.7665 3.83331 13.1667V13.5C3.83331 14.9001 3.83331 15.6002 4.1058 16.135C4.34548 16.6054 4.72793 16.9878 5.19834 17.2275C5.73312 17.5 6.43318 17.5 7.83331 17.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.7222d67cdcc2d330c74a78e71136fa4a.svg";
export { ForwardRef as ReactComponent };